<template>
    <div class="page">
        <div class="page-header">
            <div class="title h3 pl-5 text-light">Condiciones Generales</div>
        </div>
        <main>
            <div class="container">
                <condiciones/>
            </div>
        </main>
    </div>
</template>

<script>

import condiciones from '@/components/condiciones.vue';

export default {
    name: 'condiciones-generales',

    components: {
        condiciones,
    },
    data() {
        return {
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>